'use client'

import React, { useEffect } from 'react'

import { useHeaderTheme } from '@/providers/HeaderTheme'
import { LegislativeProvider } from '@/providers/LegislativeProvider'

import type { Topic } from '@/payload-types'

type PublishedBillPageClientProps = {
  billTopics: Topic[]
  billTopicCounts: { [key: number]: number }
  children: React.ReactNode
}

const PublishedBillPageClient: React.FC<PublishedBillPageClientProps> = ({
  billTopics,
  billTopicCounts = {},
  children,
}) => {
  /* Force the header to be dark mode while we have an image behind it */
  const { setHeaderTheme } = useHeaderTheme()

  useEffect(() => {
    setHeaderTheme('light')
  }, [setHeaderTheme])
  return (
    <LegislativeProvider billTopics={billTopics} billTopicCounts={billTopicCounts}>
      {children}
    </LegislativeProvider>
  )
}

export default PublishedBillPageClient
